import * as XLSX from 'xlsx'

export function downloadXlsxTemplate(
  filename: string,
  headers: string[],
  exampleRows: (string | number)[][],
  sheetName = 'Импорт',
) {
  const ws = XLSX.utils.aoa_to_sheet([headers, ...exampleRows])
  const colWidths = headers.map((h, idx) => {
    const maxExample = exampleRows.reduce((max, row) => {
      const cell = String(row[idx] ?? '')
      return Math.max(max, cell.length)
    }, 0)
    return { wch: Math.max(h.length, maxExample, 12) + 2 }
  })
  ws['!cols'] = colWidths
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, sheetName)
  XLSX.writeFile(wb, filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`)
}

export const OFFICE_USERS_IMPORT_HEADERS = ['ФИО', 'Телефон', 'Логин (e-mail)', 'Пароль']

export const OFFICE_USERS_IMPORT_EXAMPLE = [
  ['Иванов Иван Иванович', '79001234567', 'ivanov@example.com', 'TempPass123'],
  ['Петрова Анна Сергеевна', '79007654321', 'petrova@example.com', 'TempPass456'],
]

export const ORDERS_IMPORT_HEADERS = [
  'Дата создания обращения',
  'Номер обращения',
  'Стадия',
  'Причина отказа',
  'Менеджер',
  'Вид контакта',
  'Контактное лицо клиента',
  'Адрес',
  'Телефон клиента',
  'Дата замера',
  'Отв за замер',
  'Сумма заказа',
  'Предоплата',
  'Дата оплаты',
  'Номер договора',
  'Дата завершения заказа',
]

export const ORDERS_IMPORT_EXAMPLE = [
  [
    '25.08.2025',
    '17105',
    'Выполнено',
    '',
    'Иванов Иван Иванович',
    'Сайт',
    'Сидоров Алексей',
    'г. Рязань, ул. Ленина, д. 1',
    '89106123641',
    '',
    '',
    '93295',
    '93295',
    '25.08.2025',
    '10617-556',
    '04.09.2025',
  ],
]
